/* eslint-disable no-undef */
import React from 'react';
import { basename } from 'store';
import { useSearchParams } from 'react-router-dom';
import {
  Button,
  Space,
  Text,
  Modal,
  ModalContent,
  ModalDescription,
  Image,
} from '@cashfree-intl/coherent';

import exitModalIllustration from 'images/CheckoutJourney/exitModalIllustration.svg';
import { setItemsInLocalStorage } from 'utils/common';
import { sendAnalyticsData } from 'containers/ProductTour/helper';
import { ExitSetupModalProps } from 'containers/CheckoutJourney/types';

const ExitSetupModal = ({ open, onClose }: ExitSetupModalProps) => {
  const [searchParams] = useSearchParams();

  const navigateToLanding = () => {
    sendAnalyticsData('skipToDashboardClicked');
    setItemsInLocalStorage({ checkoutJourneySkipped: true });

    window.location.href = `${basename}landing${
      searchParams.get('env') ? `?env=${searchParams.get('env')}` : ''
    }`;
  };

  return (
    <Modal open={open} $maxWidth={350}>
      <ModalContent>
        <ModalDescription>
          <Image src={exitModalIllustration} alt="Exit Setup" />
          <Space direction="column" gap={2} className="mt-3">
            <Text variant="h20" weight="bold" strong>
              You are exiting our setup guide
            </Text>
            <Text variant="b14" color="#555">
              You can resume the setup guide later from the home page.
            </Text>
          </Space>
          <Space gap={2} className="mt-3">
            <Button primary onClick={onClose}>
              Continue Setup
            </Button>
            <Button onClick={navigateToLanding}>Skip to Dashboard</Button>
          </Space>
        </ModalDescription>
      </ModalContent>
    </Modal>
  );
};

export default ExitSetupModal;
